import React from "react"

const ChevronLeftSmall = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.292787 7.70637C0.105316 7.51884 0 7.26453 0 6.99937C0 6.7342 0.105316 6.47989 0.292787 6.29237L5.94979 0.635367C6.04203 0.539856 6.15238 0.463674 6.27438 0.411265C6.39639 0.358856 6.52761 0.33127 6.66039 0.330116C6.79316 0.328962 6.92484 0.354264 7.04774 0.404545C7.17064 0.454826 7.28229 0.529079 7.37618 0.622972C7.47007 0.716864 7.54433 0.828516 7.59461 0.951412C7.64489 1.07431 7.67019 1.20599 7.66904 1.33877C7.66788 1.47155 7.6403 1.60277 7.58789 1.72477C7.53548 1.84677 7.4593 1.95712 7.36379 2.04937L2.41379 6.99937L7.36379 11.9494C7.54594 12.138 7.64674 12.3906 7.64446 12.6528C7.64218 12.915 7.53701 13.1658 7.35161 13.3512C7.1662 13.5366 6.91538 13.6418 6.65319 13.644C6.39099 13.6463 6.13839 13.5455 5.94979 13.3634L0.292787 7.70637Z"
        fill="#1C1F21"
      />
    </svg>
  )
}

export default ChevronLeftSmall
